<template>
    <div>
        <a-layout style="background:#fff;">
            <a-layout-header class="header" :style="{ position: 'fixed', zIndex: 1, width: '100%' }">
                <div style="display:flex; justify-content: space-between;">
                    <p style="font-weight:bolder;"> Zhulia Seller <span style="color:#ccc;padding-right:20px;padding-left:20px;">></span> <span style="color:#ccc">Onboarding</span></p>
                    <!-- <div v-show="displayProgressBar" class="progress">
                        <a-progress 
                        :percent="displayPercent" 
                        :strokeColor="progressColor"
                        />
                    </div> -->
                    <a @click="handlleLogout" style="color:#98c14b">Exit</a>
                </div>
            </a-layout-header>
            <a-layout-content :style="{ padding: '0 50px', marginTop: '64px' }">
                <router-view/>
            </a-layout-content>
        </a-layout>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
    export default {
        name:"Entry",
        data(){
             return{
                percent: 0,
                showProgressBar:"",
                progressColor:"#418a49"
             }
        },
        computed:{
            ...mapGetters(['getShowProgressBar','getProgressBarPercentage']),
            displayProgressBar(){
                return this.showProgressBar
            },
            displayPercent(){
                return this.percent
            }
        },
        methods:{
            ...mapActions(['logout','setBusinessInfo','setStepCount']),
            handlleLogout(){
                this.setBusinessInfo(null)
                this.setStepCount(0)
                this.logout();
            }
        },
        updated(){
            if(this.getShowProgressBar){
                this.showProgressBar = this.getShowProgressBar
            }
            if(this.getProgressBarPercentage){
                this.percent = this.getProgressBarPercentage
            }
        },
    
        created(){
            // this.percent = 90;
            // console.log(this.getShowProgressBar)
            if(this.getShowProgressBar){
                this.showProgressBar = this.getShowProgressBar
            }
            if(this.getProgressBarPercentage){
                this.percent = this.getProgressBarPercentage
            }
        }
    }
</script>

<style scoped>
.ant-layout-header{
    background: #fff;
    box-shadow: 0px 0px 6px;
}
.img_size{
    max-width: 56px;
    max-height: 55px;
}
.progress{
    width: 50%;
}
.ant-progress-success-bg, .ant-progress-bg {
    position: relative;
    background-color: #418a49;
    border-radius: 100px;
    transition: all 0.4s cubic-bezier(0.08, 0.82, 0.17, 1) 0s;
}

</style>